export default {
  id: "cross-chain-transfer",
  en: {
    title: "cross-chain transfer"
  },
  ru: {
    title: "cross-chain transfer"
  }
};
